export const personalityMap = {
	"Extremely Shy": -100,
	Shy: -50,
	Flirty: 50,
	"Extremely Flirty": 100,
	Friendly: 0,
	"Extremely Pessimistic": -100,
	Pessimistic: -50,
	Optimistic: 50,
	"Extremely Optimistic": 100,
	Rational: 0,
	"Extremely Open": -100,
	Open: -50,
	Mysterious: 50,
	"Extremely Mysterious": 100,
	Ordinary: 0,
};